import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class AdminIndex extends Component {
	render() {
		return (
			<Redirect to={this.props.isAuthenticated ? '/admin/cp' : '/admin/login'} />
		);
	}
}

export default AdminIndex;


// WEBPACK FOOTER //
// ./src/admin-components/AdminIndex.js